import PropTypes from 'prop-types';
import React from 'react';
import {subjects} from "./donorProfileConstants.js";

export class SupportedSubjects extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	renderAllSubjects(){
		let supportedSubjects = this.props.supportedSubjects;
		return Object.keys(subjects).map(function (subject) {
			let supported = supportedSubjects && supportedSubjects.includes(subject);
			let photoUrl = "../images/donorpage/subjectbadges/badge-" + (supported ? "" : "outline-") + subjects[subject].iconValue + ".png"
			if (!supported && !subjects[subject].alwaysShow) {
				return null;
			}
			return (
					<div key={subject} className={"badge " + (supported ? "" : "inactive")}>
						<a href={baseURL + "donors/search.html?" + subjects[subject].searchFilter}>
							<img src={photoUrl}/>
							<p>{subject}</p>
						</a>
					</div>
			)
		});

	}

	render() {
		let numsupportedSubjects = this.props.supportedSubjects ? this.props.supportedSubjects.length : 0;
		return (
				<section className="subject-areas">
					<h2>{this.props.viewingOwnPage ? "You have" : this.props.displayName + " has"} given to {numsupportedSubjects} subject {numsupportedSubjects > 1 ? "areas" : "area"}</h2>
					<div className="subject-badges">
						{this.renderAllSubjects()}
					</div>
				</section>
		);
	}
}

SupportedSubjects.propTypes = {
	supportedSubjects: PropTypes.array,
	displayName: PropTypes.string.isRequired,
	viewingOwnPage: PropTypes.bool.isRequired
};
